export const REPLAY_QUESTION = `Do you replay conversations and wish you'd said something differently?`

export const REPLAY_OPTIONS = [
  { key: 'yesAllTheTime', i18nKey: 'yesAllTheTime' },
  { key: 'yesSometimes', i18nKey: 'yesSometimes' },
  { key: 'never', i18nKey: 'never' },
] as const

export type TReplayAnswerKey = typeof REPLAY_OPTIONS[number]['key']

export const REPLAY_FEEDBACK: Record<
  TReplayAnswerKey,
  { badge: string; text: string }
> = {
  yesAllTheTime: {
    badge: 'onboarding.communicationReplay.feedback.yesAllTheTime.badge',
    text: 'onboarding.communicationReplay.feedback.yesAllTheTime.text',
  },
  yesSometimes: {
    badge: 'onboarding.communicationReplay.feedback.yesSometimes.badge',
    text: 'onboarding.communicationReplay.feedback.yesSometimes.text',
  },
  never: {
    badge: 'onboarding.communicationReplay.feedback.never.badge',
    text: 'onboarding.communicationReplay.feedback.never.text',
  },
}
